import { FC } from 'react';
import {
  SectionBreadcrumbs,
  SectionBreadcrumbsProps,
} from '../../common/SectionBreadcrumbs';
import { DATA_OBJECT_GROUP_ROUTES } from './DataObjectGroups';

export interface DataObjectGroupBreadcrumbsData {
  name: string;
  code: string;
}

export type DataObjectGroupBreadcrumbsProps = Omit<
  SectionBreadcrumbsProps<DataObjectGroupBreadcrumbsData>,
  'routes'
>;

export const DataObjectGroupBreadcrumbs: FC<DataObjectGroupBreadcrumbsProps> = (
  props
) => <SectionBreadcrumbs {...props} routes={DATA_OBJECT_GROUP_ROUTES} />;
